import { captureException } from '@/src/config/sentry'
import { GTM } from '@/src/general/utils/gtm'
import { EVENTS } from '@/src/general/utils/gtm/constants'

import type { PUSH_EVENT_LABEL } from '../../../models/notification.constants'

export type TOfferPushNotificationsProps = {
  eventLabel: PUSH_EVENT_LABEL
}

/* Trigger an authorization request */
export const offerPushNotifications = async ({ eventLabel }: TOfferPushNotificationsProps) => {
  GTM.sendEvent(EVENTS.PUSH_PERMISSION_TRIGGERED, { eventLabel })

  try {
    const permission = await Notification.requestPermission()
    GTM.sendEvent(
      {
        granted: EVENTS.PUSH_PERMISSION_GRANTED,
        denied: EVENTS.PUSH_PERMISSION_DENIED,
        default: EVENTS.PUSH_PERMISSION_IGNORED,
      }[permission],
      { eventLabel },
    )
    return permission
  } catch (error) {
    captureException.then((f) => f(error))
    return null
  }
}
